import { render, staticRenderFns } from "./robotDialogue.vue?vue&type=template&id=09f85e23&scoped=true"
import script from "./robotDialogue.vue?vue&type=script&lang=js"
export * from "./robotDialogue.vue?vue&type=script&lang=js"
import style0 from "./robotDialogue.vue?vue&type=style&index=0&id=09f85e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f85e23",
  null
  
)

export default component.exports